import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  contentPadding: {
    padding: theme.spacings.md,
  },
  contentText: {
    fontSize: theme.fontSizes.xl,
  },
  fullscreenModal: {
    margin: 0,
  },
  fullscreenSafeArea: {
    flex: 1,
    backgroundColor: theme.colors.white,
  },
  fullscreenContent: {
    flex: 1,
  },
  fullscreenButtonRow: {
    padding: theme.spacings.md,
  },
});
